<template>
  <div>
    <custom-account-transaction-label :accountTransaction="accountTransaction" v-if="accountTransaction.origin !== 't'" @openBillPaymentModal="$emit('openBillPaymentModal', $event)"/>
    <transfer-label :accountTransaction="accountTransaction" v-if="accountTransaction.origin == 't'"/>
  </div>
</template>

<script>

import CustomAccountTransactionLabel from "@/components/account/sections/CustomAccountTransactionLabel.vue";
import TransferLabel from "@/components/account/sections/TransferLabel.vue";

export default {

  components : {
    CustomAccountTransactionLabel,
    TransferLabel,
  },

  props: {
    accountTransaction: {},
  },

  data: () => ({
    origin: {
      o: {
        text: "Vendas",
        icon: "fas fa-shopping-cart",
      },
      br: {
        text: "Contas a receber",
        icon: "fas fa-file-invoice-dollar",
      },
      bp: {
        text: "Contas a pagar",
        icon: "fas fa-file-invoice-dollar",
      },
      c: {
        text: "Lançamento",
        icon: "fas fa-pen",
      },
      t: {
        text: "Transferência",
        icon: "fas fa-exchange-alt",
      },
      dd: {
        text: "Ajuste de Caixa",
        icon: "fas fa-hand-holding-usd",
      },
    },
  }),
};
</script>

<style>
</style>